import React from 'react';

const COLORS = {
    'AI Agent': '#6366f1',
    'Traditional Bot': '#3b82f6',
    'Manual (Portal)': '#10b981',
    'Manual (WhatsApp)': '#f59e0b',
};

/**
 * Lightweight donut chart using SVG — no heavy chart library needed.
 * Shows usage breakdown: AI vs Bot vs Manual.
 */
export default function UsagePieChart({ data }) {
    if (!data || !data.breakdown || Object.keys(data.breakdown).length === 0) {
        return (
            <div className="analytics-empty">
                <p>No usage data yet</p>
            </div>
        );
    }

    const entries = Object.entries(data.breakdown);
    const total = data.total || entries.reduce((s, [, v]) => s + v, 0);

    // Calculate SVG donut segments
    const radius = 70;
    const circumference = 2 * Math.PI * radius;
    let cumulativeOffset = 0;

    const segments = entries.map(([label, value]) => {
        const percentage = total > 0 ? value / total : 0;
        const dashArray = percentage * circumference;
        const dashOffset = -cumulativeOffset;
        cumulativeOffset += dashArray;

        return { label, value, percentage, dashArray, dashOffset, color: COLORS[label] || '#94a3b8' };
    });

    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '24px', flexWrap: 'wrap' }}>
            {/* SVG Donut */}
            <svg width="160" height="160" viewBox="0 0 160 160" style={{ flexShrink: 0 }}>
                {segments.map((seg, i) => (
                    <circle
                        key={i}
                        cx="80"
                        cy="80"
                        r={radius}
                        fill="none"
                        stroke={seg.color}
                        strokeWidth="18"
                        strokeDasharray={`${seg.dashArray} ${circumference - seg.dashArray}`}
                        strokeDashoffset={seg.dashOffset}
                        transform="rotate(-90 80 80)"
                        style={{ transition: 'stroke-dasharray 0.6s ease' }}
                    />
                ))}
                {/* Center label */}
                <text x="80" y="76" textAnchor="middle" fontSize="22" fontWeight="700" fill="var(--text)">
                    {total}
                </text>
                <text x="80" y="96" textAnchor="middle" fontSize="11" fill="var(--text-secondary)">
                    responses
                </text>
            </svg>

            {/* Legend */}
            <div className="usage-legend">
                {segments.map((seg, i) => (
                    <div className="usage-legend-item" key={i}>
                        <span className="usage-legend-dot" style={{ backgroundColor: seg.color }} />
                        <span>{seg.label}</span>
                        <span className="usage-legend-value">
                            {Math.round(seg.percentage * 100)}%
                        </span>
                    </div>
                ))}
            </div>
        </div>
    );
}
